import { ColorType } from '@/app/common/components/Badge'
import { removeUnderscoresAndMakeFirstLetterCapital } from '@/app/pages/payment-approval-rules/utils'
import {
  DatabusMessageLog,
  DatabusProcessingStatus,
} from '@/queries/databus_message_logs/schema'

export function getDatabusProcessingStatus(log: DatabusMessageLog) {
  return log.message_direction === 'Outbound'
    ? log.outbound_status
    : log.inbound_processing_status
}

export function formatDatabusStatus(status: DatabusProcessingStatus | null) {
  return status ? removeUnderscoresAndMakeFirstLetterCapital(status) : '-'
}

export function getDatabusStatusColor(
  status: DatabusProcessingStatus
): ColorType {
  if (status === 'processed_success' || status === 'delivered') {
    return 'Positive'
  }

  if (status === 'processed_failed' || status === 'failed') {
    return 'Negative'
  }

  if (status === 'pending' || status === 'received' || status === 'retried') {
    return 'Notice'
  }

  return 'Neutral'
}
